import React from "react";

const HistoryAndTreatment = () => {
  let eyeIcon = (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.62305 16.5C2.91555 9.46 9.08517 4.125 16.4992 4.125C23.9132 4.125 30.0814 9.46 31.3753 16.5C30.0828 23.54 23.9132 28.875 16.4992 28.875C9.08517 28.875 2.91692 23.54 1.62305 16.5H1.62305ZM16.4983 23.3759C20.2952 23.3759 23.3733 20.2978 23.3733 16.5009C23.3733 12.7039 20.2953 9.62587 16.4983 9.62585C12.7014 9.62584 9.62331 12.7039 9.62329 16.5008C9.62327 20.2978 12.7013 23.3758 16.4982 23.3759H16.4983ZM16.4993 20.625C15.0255 20.625 13.6638 19.8388 12.9269 18.5625C12.1901 17.2862 12.1901 15.7138 12.9269 14.4375C13.6638 13.1612 15.0255 12.375 16.4993 12.375C17.973 12.375 19.3348 13.1612 20.0716 14.4375C20.8085 15.7138 20.8085 17.2862 20.0716 18.5625C19.3348 19.8388 17.973 20.625 16.4993 20.625Z"
        fill="#4C004A"
      />
    </svg>
  );
  let nextIcon = (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5" cy="12.5" r="12.5" fill="#0D46C1" fill-opacity="0.2" />
      <path
        d="M7.08317 12.5002C7.08317 12.1262 7.38631 11.8231 7.76025 11.8231H15.3097L12.009 8.52238C11.7392 8.2526 11.7431 7.81403 12.0175 7.54906C12.2853 7.29062 12.7107 7.29437 12.9738 7.5575L17.8629 12.4465C17.8925 12.4762 17.8925 12.5242 17.8629 12.5538L12.9748 17.4418C12.7125 17.7042 12.2872 17.7041 12.0248 17.4418C11.7634 17.1803 11.7624 16.7566 12.0227 16.494L15.3097 13.1772H7.76025C7.38631 13.1772 7.08317 12.8741 7.08317 12.5002Z"
        fill="#4C004A"
      />
    </svg>
  );
  let editIcon = (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6007 0.314537C18.182 -0.104194 17.5149 -0.104194 17.0962 0.314537L9.01295 8.39773C8.88521 8.51841 8.80005 8.67451 8.74327 8.84483L7.42328 13.2519C7.30971 13.6281 7.41617 14.0326 7.69295 14.3094C7.89164 14.5152 8.16842 14.6216 8.44521 14.6216C8.54453 14.6216 8.651 14.6074 8.75037 14.579L13.1574 13.259C13.3278 13.2022 13.4839 13.1171 13.6045 12.9894L21.6878 4.90613C21.8865 4.70744 22 4.43776 22 4.15388C22 3.87003 21.8865 3.60035 21.6878 3.40162L18.6007 0.314537Z"
        fill="#4C004A"
      />
      <path
        d="M20.9355 9.93793C20.3474 9.93793 19.871 10.4147 19.871 11.0024V18.0992C19.871 19.0778 19.075 19.8734 18.0968 19.8734H3.90323C2.92499 19.8734 2.12903 19.0778 2.12903 18.0992V3.90567C2.12903 2.92709 2.92499 2.13147 3.90323 2.13147H11C11.588 2.13147 12.0645 1.65466 12.0645 1.06696C12.0645 0.479259 11.588 0.00244141 11 0.00244141H3.90323C1.75098 0.00244141 0 1.75376 0 3.90567V18.0992C0 20.2511 1.75098 22.0024 3.90323 22.0024H18.0968C20.249 22.0024 22 20.2511 22 18.0992V11.0024C22 10.4147 21.5235 9.93793 20.9355 9.93793Z"
        fill="#4C004A"
      />
    </svg>
  );

  return (
    <>
      <div className="grid grid-cols-2 gap-10 p-10">
        <div>
          <p>
            Reason For Visit{" "}
            <span className="text-gray-500 text-sm">Default value set</span>
          </p>
          <textarea
            className="w-full bg-gray-100 rounded-md"
            rows="10"
            placeholder="Routine, Distance"
          />
        </div>

        <div>
          <p>
            POH <span className="text-gray-500 text-sm">Default value set</span>
          </p>
          <textarea
            className="w-full bg-gray-100 rounded-md"
            rows="10"
            placeholder="Type here"
          />
        </div>

        <div>
          <p>
            GH <span className="text-gray-500 text-sm">Default value set</span>
          </p>
          <textarea
            className="w-full bg-gray-100 rounded-md"
            rows="10"
            placeholder="Good"
          />
        </div>

        <div>
          <p>Medication</p>
          <textarea
            className="w-full bg-gray-100 rounded-md"
            rows="10"
            placeholder="None"
          />
        </div>

        <div>
          <p>
            Family General Health(FGH){" "}
            <span className="text-gray-500 text-sm">Default value set</span>
          </p>
          <textarea
            className="w-full bg-gray-100 rounded-md"
            rows="10"
            placeholder="No Significat Headache"
          />
        </div>

        <div>
          <p>
            Family Ocular Healt(FOH){" "}
            <span className="text-gray-500 text-sm">Default value set</span>
          </p>
          <textarea
            className="w-full bg-gray-100 rounded-md"
            rows="10"
            placeholder="No Significat Hx. No glaucoma"
          />
        </div>
      </div>
      <div className="text-right">
        <button
          type="button"
          className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2"
        >
          {eyeIcon} &nbsp;&nbsp; Patient Previous Examination
        </button>
      </div>
      <div>
        <hr className="w-[90%] m-auto" />
      </div>

      <div className="">
        <div className="flex justify-between w-[90%] m-auto flex-wrap">
          <div>
            <p>Medication</p>
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">ATENOLOLO</label>
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">XALATAN</label>
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">BENDROFLUMETHIAZIDE</label>
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">FUROSIMIDE</label>
            <br />
            <br />
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">GLICLAZIDE</label>
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">INSLIN</label>
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">METFORMIN HYDROCHLORIDE</label>
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">OMEPRAZOLE</label>
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">RAMIPRIL</label>
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">STATIN</label>
            <br />
          </div>

          <div className="border-r-2 pr-10">
            <br />
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">THYROXINE</label>
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">TIMOLOL</label>
            <br />
            <input checked={true} id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">TIMOPTOL</label>
          </div>

          <div className="mr-60">
            <br />
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">Patient Has Glaucoma</label>
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">
              Patient Has Family History of Glaucoma
            </label>
            <br />
            <input id="check1" type="checkbox" />
            &nbsp; &nbsp;
            <label htmlFor="check1">Patient Has Diabetic</label>
          </div>
        </div>
        <div className="text-right">
          <button
            type="button"
            className="text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2"
          >
            {editIcon} &nbsp;&nbsp; Patient Lifestyle Notes
          </button>
        </div>
      </div>
      <div>
        <hr className="w-[90%] m-auto" />
      </div>

      <div className="p-16">
        <p className="text-gray-400">Click to MMS Website</p>
        <p className="text-xl">Other Notes:</p>
        <textarea
          className="w-full bg-gray-100 rounded-md"
          rows="10"
          placeholder="Type Here"
        ></textarea>
        <div className="text-right my-5 ml-3">
          <button
            type="button"
            className="bg-blue-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2 border border-blue-500 text-blue-500"
          >
            {nextIcon} &nbsp;&nbsp; Save And Continue
          </button>
        </div>
      </div>
    </>
  );
};

export default HistoryAndTreatment;
